export default "__VITE_ASSET__DXarBY3d__"